import { faAnglesRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import GroupCardV2 from './GroupCardV2'
import { Button } from 'antd'
import React from 'react'

const formatPlacement = (position) => {
  if (position === 1) return '1st'
  if (position === 2) return '2nd'
  if (position === 3) return '3rd'
  return '4th'
}

export default function GroupFormV2({ groupRankings, isAdmin, rankings, scorecard, setGroupRankings, setStep }) {
  const groups = Object.entries(scorecard.groups ?? {})
  const completedGroups = groups.filter(([groupName, teams]) => (groupRankings[groupName] ?? []).length === teams.length).length
  const autoRankCountries = () => {
    const rankedGroups = groups.reduce((nextGroups, [groupName, group]) => {
      const placements = [...group]
        .map(country => {
          const ranking = rankings[String(country)]
          return {
            value: country,
            name: ranking?.name ?? String(country),
            rank: typeof ranking?.rank === 'number' ? ranking.rank : Number.MAX_SAFE_INTEGER
          }
        })
        .sort((teamA, teamB) => {
          if (teamA.rank !== teamB.rank) return teamA.rank - teamB.rank
          return teamA.name.localeCompare(teamB.name)
        })
        .map(team => team.value)

      nextGroups[groupName] = placements
      return nextGroups
    }, {})

    setGroupRankings(rankedGroups)
  }

  return (
    <div className="bracket-group-form">
      <div className="groups-header">
        <h1 className="wc-font">Group Stage</h1>
        <p className="wc-font header-description">Rank every team in each group from 1 through 4.</p>
        <p className="wc-font header-description">{`${completedGroups} of ${groups.length} groups ranked`}</p>
        {isAdmin && <Button onClick={autoRankCountries}>Auto-rank countries</Button>}
      </div>
      <div className="groups-container">
        {groups.map(([name, group]) => {
          const teams = [...group]
            .sort((a, b) => String(a).localeCompare(String(b)))
            .map(country => {
              const ranking = rankings[String(country)]
              return ranking
                ? { ...ranking, value: country }
                : { value: country, name: String(country), rank: null, flag: '/flags/Mystery.png' }
            })

          return (
            <GroupCardV2
              key={name}
              group={teams}
              name={name}
              placements={groupRankings[name] ?? []}
              setPlacements={(placements) => setGroupRankings(current => ({ ...current, [name]: placements }))}
              formatPlacement={formatPlacement}
            />
          )
        })}
      </div>
      <div className="groups-footer">
        <Button disabled={completedGroups !== groups.length} type="primary" onClick={() => {
          setStep(2)
          window.scrollTo(0, 0)
        }}>
          Continue to Advancing Third Place Teams&nbsp;
          <FontAwesomeIcon icon={faAnglesRight} />
        </Button>
      </div>
    </div>
  )
}
